@if (content?.links?.length) {
  <div class="center "
    >
    <div class="wrap center p2 m-b-2">
      {{ message }}
    </div>
    <carousel class="p-b p-t center p-l-4-s p-l-4-m search-quicklinks"
      [slidesPerView]="'auto'"
      [navigation]="false"
      [scrollbar]="false"
      [loop]="false">
      @for (link of content.links; track link) {
        <ng-template swiperSlide>
          <href class="quick-link cursor-pointer p1 b-radius-max p-a-2 m-r m-b-5 m-b-4-s bg-col-5 no-wrap inline-block "
            [link]="link.link"
          *iCms="'label' of link"></href>
        </ng-template>
      }
    </carousel>
  </div>
}